'use client';
import { scaledRemCalc } from '@mnd-frontend/utils';
import { type ReactNode, useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { useSvgContext } from '../context';

const GraphWrapperStyles = styled.div<{ $hidden?: boolean; $horizontal?: boolean }>`
  display: flex;
  flex-direction: ${props => (props.$horizontal ? 'row' : 'column')};
  flex-wrap: ${props => props.$horizontal && 'wrap'};
  align-items: ${props => props.$horizontal && 'center'};
  justify-content: ${props => props.$horizontal && 'center'};
  gap: ${scaledRemCalc(32)};
  padding: 0;
  > *:first-child {
    flex-shrink: 1;
  }

  transition: opacity 0.125s linear;
  opacity: ${props => (props.$hidden ? 0 : 1)};
  overflow: hidden;
`;

export const GraphWrapper = ({
  children,
  horizontal,
}: {
  children: ReactNode;
  horizontal?: boolean;
}) => {
  // Following is a hack to avoid showing the graph before the scale has been calculated
  const [hidden, setHidden] = useState(true);
  const scaleLastChangedAt = useRef<number | undefined>();
  const { left, bottom } = useSvgContext();

  // biome-ignore lint/correctness/useExhaustiveDependencies: No idea why
  useEffect(() => {
    scaleLastChangedAt.current = Date.now();
  }, [left, bottom]);

  useEffect(() => {
    if (!hidden) return;

    const interval = setInterval(() => {
      if (scaleLastChangedAt.current === undefined) return;
      if (Date.now() - scaleLastChangedAt.current > 75) {
        setHidden(false);
      }
    }, 20);
    return () => clearInterval(interval);
  }, [hidden]);

  return (
    <GraphWrapperStyles $horizontal={horizontal} $hidden={hidden}>
      {children}
    </GraphWrapperStyles>
  );
};
